module.exports = __webpack_public_path__ + "images/pages/for_business/pc/case1_1f189082e5652c28d6836f6067bbe65c.png";